import { Component, Input, Output, EventEmitter } from '@angular/core';

import { ApprovalModel } from 'rev-shared/media/ApprovalModel';
import { ApprovalStatusInfo } from './ApprovalStatusInfo';

import styles from './approver-request.module.less';

@Component({
	selector: 'approval-request',
	templateUrl: './ApprovalRequest.Component.html'
})
export class ApprovalRequestComponent {
	@Input() private isVideoApprover: boolean;
	@Input() public isMediaAdmin: boolean;
	@Input() public isSubmitted: boolean;
	@Input() public isVideoUploader: boolean;
	@Input() public approvalDetails: ApprovalModel;
	@Input() public statusInfo: ApprovalStatusInfo;
	@Input() public templates: any[];

	@Output() public onApprovalSubmit: EventEmitter<any> = new EventEmitter();
	@Output() public onDeleteVideo: EventEmitter<void> = new EventEmitter();

	public readonly styles = styles;

	public get showTemplateList(): boolean {
		return (this.templates || []).length > 1;
	}

	public get isOnlyVideoUploader(): boolean {
		return this.isVideoUploader && !this.isVideoApprover && !this.isMediaAdmin;
	}

	public approvalSubmit(): void {
		const templateId = this.approvalDetails.selectedTemplateId
			|| this.templates[0].id;

		this.onApprovalSubmit.emit({ templateId });
	}

	public deleteVideo(): void {
		this.onDeleteVideo.emit();
	}
}
